// extracted by mini-css-extract-plugin
export default {"paragraph":"Paragraph_paragraph__9qzgT","primary":"Paragraph_primary__bdJBN","second":"Paragraph_second__OFpwY","gost":"Paragraph_gost__6xG99"};